import React from 'react';
import CssDropdown from 'library/structures/css-dropdown';
import { NavLink } from 'library/util/core-router';
import { NavLinks } from 'apps/admin/components/tools-dropdown/admin-tool-links';

const ToolsDropdown = () => {
  return (
    <CssDropdown label="Tools v">
      {Object.keys(NavLinks).map((componentName) => {
        return (
          <NavLink key={componentName} to={NavLinks[componentName]}>
            {componentName}
          </NavLink>
        );
      })}
    </CssDropdown>
  );
};

export default ToolsDropdown;
